import { fetchHandler } from "../Handler/Handler";

export const POSTVendorDESCTYpe = async (slugname, data) => {
    try {

        const response = await fetchHandler({
            method: "POST",
            endpoint: `/descriptiontype/vendor/${slugname}/select`,
            data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const GetVendordescriptionsTYPe = async (slugname) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/descriptiontype/vendor/${slugname}/descriptiontypes`,
            data: null
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};

export const GETSingleDESTYPe = async (slugname, id,) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/descriptiontype/vendor/${slugname}/descriptiontypes/${id}`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};


export const UpdateDESVendorTYPe = async (slugname, data, id) => {
    try {

        const response = await fetchHandler({
            method: "PUT",
            endpoint: `/descriptiontype/vendor/${slugname}/${id}`,
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const UpdatestatusVendorDESTYPe = async (slugname, data, id) => {
    try {

        const response = await fetchHandler({
            method: "PATCH",
            endpoint: `/descriptiontype/vendor/${slugname}/status/${id}`,
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const DELETEDESvendorTYPe = async (slugname, id) => {
    try {
        const response = await fetchHandler({
            method: "DELETE",
            endpoint: `/descriptiontype/vendor/${slugname}/${id}`,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};

export const GETSingledesbydesname = async (slugname, id) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/description/vendor/${slugname}/descriptionnames/${id}`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
}